import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #fdf8f4;
    --navy: #fdf8f4;
    --light-navy: #fdf8f4;
    --lightest-navy: #fdb137;
    --navy-shadow: rgba(2, 12, 27, 0.7);
    --dark-slate: #fdb137;
    --slate: #1d2d5f; /** main text */
    --light-slate: #36454F;
    --lightest-slate: #1d2d5f;
    --white: #e6f1ff;
    --green: #fdb137;
    --green-tint: rgba(250, 250, 51, 0.1);
    --pink: #f57dff;
    --blue: #57cbff;
    --red: #e95538;
    --yellow: #fdb137;
    --purple: #1d2d5f;
    --darkgrey: #252016;
    --charcoal: #36454F

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
